import React from 'react';
interface HeaderProps {
  title: string;
  subtitle?: string;
}
export function Header({
  title,
  subtitle
}: HeaderProps) {
  return <div className="bg-white border-b px-8 py-6" data-id="element-42">
      <h1 className="text-2xl font-semibold text-gray-900" data-id="element-43">{title}</h1>
      {subtitle && <p className="text-gray-600 mt-1" data-id="element-44">{subtitle}</p>}
    </div>;
}